import { filter, findIndex, includes, keys } from 'lodash';
import ColorManager from '../../../../common/d3/ColorManager';
import { VIZ_OPTION_IDS } from '../../../../common/Constants';
import { Viz } from '../../../VizUtil';

export const generateColorForColorGroup = ({
  viz,
  legendGroupData,
  currentId,
  fields = [],
}) => {
  const customColors = Viz.getOptionFromViz({
    viz,
    option: VIZ_OPTION_IDS.customColors,
    defaultValue: {},
  });
  const nonCustomColorGroups = filter(
    legendGroupData,
    ({ id }) => !includes(keys(customColors?.colorGroup || {}), id),
  );
  const nonCustomColorGroupIdx = findIndex(nonCustomColorGroups, [
    'id',
    currentId,
  ]);

  return ColorManager.getColorForColorGroup(
    viz.id,
    currentId,
    nonCustomColorGroupIdx < 0 ? null : nonCustomColorGroupIdx,
    fields,
  );
};
